import { ChainId } from 'shardex-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_ADDRESS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xa64D6AFb48225BDA3259246cfb418c0b91de6D7a',
  [ChainId.TESTNET]: '0x116a4C39256212D3A18Dadd2148F36C29DF10DA4',
}

export { MULTICALL_ABI, MULTICALL_ADDRESS }
